module.exports = __webpack_public_path__ + "static/media/sl.0ab96fdf.svg";